export default __webpack_public_path__ + "images/symbol--quotation-mark--double--left.svg";